<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" md="6">
        <v-btn color="#7BC243" to="/farmers/view" class="white--text cataloguebtn">View All Farmers</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div :class="paginatedItems.length === 7 ? 'catalogued_box' : 'catalogued_box_empty'">
          <v-card-text>
            <v-row>
              <v-col cols="6" md="6">
                <h5 class="accent--text" style="font-size: 12px; font-weight:700"> {{title}} </h5>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="3">
                <h4 class="accent--text" style="font-size: 12px; font-weight:700"> Current Limit : <span class="amount"> {{
                    currentLimits | formatCurrency
                  }} </span></h4>
              </v-col>
            </v-row>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Loan Ref</th>
                <th scope="col">Amount Borrowed</th>
                <th scope="col">Transfer Type</th>
                <th scope="col">Internal Disburse Status</th>
                <th scope="col">External Disburse Status</th>
                <th scope="col">Comment</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in paginatedItems" v-bind:key="item.id">
                <td> {{ item.dateCreated }}</td>
                <td> {{ item.referenceId }}</td>
                <td> {{ item.amount | formatCurrency }}</td>
                <td> {{ item.paymentType }}</td>
                <td> {{ item.disburseStatus.statusName }}</td>
                <td> {{ item.paymentType === 'INTERNALFT'?item.disburseStatus.statusName: item?.partnerStatus?.statusName}}</td>
                <td> {{ item.narration }}</td>

              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import { mapState } from 'vuex'

export default {
	name: 'FarmerLoanHistory',
	data: function () {
		return {
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			permissions: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			documentId: 0
		}
	},
	computed: {
		...mapState({
			limit: state => state.farmer.limit

		}),
		currentLimits () {
			return this.items?.borrowerLimit?.availableBalance
		},
		title () {
			return 'Loan History for ' + ' ' + this.items?.borrowerLimit?.name + ' Mobile ' + this.items?.borrowerLimit?.mobileNumber
		}
	},
	watch: {
		items: function () {
			this.numberOfLinks = Math.ceil(this.items?.loanHistory?.length / this.numberOfItemsPerPage)
			this.paginatedItems = this.paginationMethod(this.items?.loanHistory, 1, this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.paginationMethod(this.items?.loanHistory, val, this.numberOfItemsPerPage)
		}
	},
	mounted () {
		this.getFarmerLoanDetails()
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getFarmerLoanDetails () {
			const url = config.serverURI + '/disbursement/farmer/history/' + this.$route.params.organizationId + '/' + this.$route.params.farmerId
			axios.get(url)
				.then(response => {
					this.items = response.data
				})
				.catch(error => {
					console.log('error', error.response)
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		}
	}
	// ,
	// created () {
	// 	this.$store.dispatch('farmer/getFarmerLimit', this.$route.params.farmerId)
	// }
}

</script>
<style scoped >
.catalogued_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box:after, .catalogued_box:before {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogued_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogued_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.amount {
  color: black;
  font-weight: 700;
  font-size: 14px;
}
</style>
